import React, { useMemo } from 'react';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import Button from '../../components/shared/buttons/Button';
import Row from '../../components/shared/table/Row';
import SelectableRow from '../../components/shared/table/SelectableRow';
import Table from '../../components/shared/table/Table';
import { formatPrice } from '../../utils/formatter';

const PartsTable = ({ parts, loading, onPartClick, onPartDeleteClick, readOnly }) => {
  const tableRows = useMemo(
    () =>
      parts.map((part, i) => (
        <SelectableRow key={i} onClick={() => onPartClick(part)}>
          <Row children={part.name} />
          <Row children={formatPrice(part.price)} />
          {!readOnly && (
            <Row
              children={
                <div title="Видалити" className="w-full text-end z-10">
                  <Button
                    onClick={(event) => {
                      event.stopPropagation();
                      onPartDeleteClick(part);
                    }}
                    variant="secondary2"
                    disabled={loading}
                  >
                    <MdOutlineDeleteOutline size={20} />
                  </Button>
                </div>
              }
            />
          )}
        </SelectableRow>
      )),
    [readOnly, onPartDeleteClick, loading, parts, onPartClick],
  );

  return <Table columns={readOnly ? readOnlyColumns : columns} data={tableRows} onRowClick={() => ({})} />;
};

const readOnlyColumns = [
  { name: 'Назва', className: 'w-[90%]' },
  { name: 'Ціна', className: 'w-[10%]' },
];

const columns = [
  { name: 'Назва', className: 'w-[80%]' },
  { name: 'Ціна', className: 'w-[15%]' },
  { name: 'Дії', className: 'w-[5%] text-center' },
];

export default PartsTable;
